module.exports = __webpack_public_path__ + "static/media/cat-hospitality-services.7aa2e615.jpg";